// export {default as SalesList} from './List'
import '../Reports.css'

export { default as CostoMateriaPrimaReport } from './Report'
